<script>
import { closest } from 'vue-xpc/src/utils/util.js';
export default {
  name: 'RtGlobalEditor',
  props: {
    vNode: [Array, String, Object, Number, Function],
    prop: String,
    row: Object,
    rules: [Array, String, Object, Function],
    needImmediateValidate: Boolean
  },
  data () {
    return {
      editForm: {},
      componentName: '',
      isError: false,
      errorMsg: ''
    };
  },
  computed: {
    isOverScreen () {
      let result = false;
      if (this.$parent) {
        const tableEl = this.$parent.$el
          .querySelector('.el-table__body-wrapper')
          .getBoundingClientRect();
        result =
          this.$parent.editPosition.x < 0 ||
          this.$parent.editPosition.x >
            tableEl.width - this.$parent.editPosition.originWidth;
      }

      return result;
    }
  },
  created () {
    this.$set(this.editForm, this.prop, this.row[this.prop]);
  },
  mounted () {
    this.$nextTick(() => {
      if (this.needImmediateValidate) {
        this.onValidate();
      }
    });
    document.addEventListener('keyup', this.handleKeyUp);
    document.addEventListener('mouseup', this.handleClickOutside);
    if (this.$parent.appBody) {
      this.$parent.appBody.addEventListener('scroll', this.closeValidate);
    }
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.handleClickOutside);
    document.removeEventListener('keyup', this.handleKeyUp);
    if (this.$parent.appBody) {
      this.$parent.appBody.removeEventListener('scroll', this.closeValidate);
    }
  },
  methods: {
    handleKeyUp (e) {
      const theEvent = e || window.event;
      const code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code === 13) {
        const lookupDialogEl = document.querySelectorAll('.lookup-dialog');
        let dialogArr = [];
        document.querySelectorAll('.lookup-dialog').forEach(item => {
          dialogArr.push(item.style.display);
        });
        if (lookupDialogEl.length && dialogArr.some(i => i !== 'none')) {
          return false;
        }
        this.onValidate(() => {
          this.$emit('edit-update');
        });
        return false;
      }
      if (code === 27) {
        this.$emit('edit-esc');
        return false;
      }
    },

    closeValidate () {
      document.querySelector('.rt-picklist-popper').style.display = 'none';
      this.isError = false;
    },
    validateFunc (valid, message) {
      this.isError = !valid;
      this.errorMsg = message;
    },
    handleClickOutside (e) {
      const isInExact = !!(
        closest(e.target, '.rt-table-cell-editor') ||
        closest(e.target, '.rt-picklist-popper') ||
        closest(e.target, '.plat-base-autocomplete-suggestion') ||
        closest(e.target, '.lookup-dialog')
      );
      if (!isInExact) {
        this.onValidate(() => {
          this.$emit('edit-update');
        });
      }
    },
    onValidate (callback = null) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          callback && callback();
        } else {
          this.$emit('validate-error');
        }
      });
    }
  },
  render (h) {
    let el = h('div');
    if (this.vNode) {
      const vNode =
        this.vNode({
          row: this.row
        })[0] || {};
      if (vNode.componentOptions) {
        this.componentName = vNode.componentOptions.Ctor.options.name;
        const changeFunc = [
          vNode.componentOptions.listeners &&
            vNode.componentOptions.listeners.change,
          val => {
            this.$set(this.editForm, this.prop, val);
            if (vNode.componentOptions.tag !== 'rt-lookup') {
              this.onValidate(() => {
                this.$emit('edit-update');
              });
            }
          }
        ];
        const inputFunc = [
          vNode.componentOptions.listeners &&
            vNode.componentOptions.listeners.input,
          val => {
            this.$set(this.editForm, this.prop, val);
          }
        ];
        vNode.componentOptions.listeners = {
          ...vNode.componentOptions.listeners,
          change: changeFunc.filter(f => f),
          input: inputFunc.filter(f => f)
        };
        if (this.componentName === 'RtLookup') {
          const confirmFunc = [
            vNode.componentOptions.listeners &&
              vNode.componentOptions.listeners.confirm,
            val => {
              this.$set(this.editForm, this.prop, val);
              this.onValidate(() => {
                this.$emit('edit-update');
              });
            }
          ];
          vNode.componentOptions.listeners = {
            ...vNode.componentOptions.listeners,
            confirm: confirmFunc.filter(f => f)
          };
        }
        el = vNode;
        this.$setTimeout(() => {
          if (!this.isOverScreen) {
            if (this.componentName === 'RtPicklist') {
              el.componentInstance && el.componentInstance.selectOption();
            } else if (
              el &&
              el.componentInstance &&
              el.componentInstance.$children &&
              el.componentInstance.$children[0] &&
              el.componentInstance.$children[0].selectOption
            ) {
              el.componentInstance.$children[0].selectOption();
            } else {
              const ele = this.$refs.ruleForm.$el.getElementsByTagName(
                'input'
              )[0];
              ele.focus();
            }
          }
        }, 100);
      }
    }
    return (
      <div>
        <rt-form
          class="rt-table-cell-editor-form"
          ref="ruleForm"
          model={this.editForm}
          attrs={{ model: this.editForm }}
          rules={this.rules}
          autoJumpTo={false}
          onImmediateValidate={this.validateFunc}
        >
          <rt-tooltip
            manual
            opacity={1}
            disabled={this.isOverScreen || !this.isError}
            value={this.isError}
            background-color="danger"
            content={this.errorMsg}
            placement="top"
          >
            <rt-form-item prop={this.prop} hiddenLabel is-show-message={false}>
              {el}
            </rt-form-item>
          </rt-tooltip>
        </rt-form>
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtTableCellEditor.vue?61d56b89